/**
 * Split out from `TileAnimDemoPanel.tsx` so `LobbyClient` can import the
 * `TileAnimKind` union + `buildAnimState` factory without dragging the
 * ~360-line panel component (icons, sound hooks, stress-test buttons)
 * into the main lobby chunk. The panel itself is lazy-mounted via
 * `next/dynamic` in `LobbyClient` for dev mode only.
 */

import type { TileAnimState } from '../board-canvas/TileEffectsOverlay';

export type TileAnimKind =
  | 'buyout'
  | 'claim'
  | 'forfeit'
  | 'waterfall'
  | 'dutchAuction'
  | 'reset';

/** Factory that builds the in-flight animation state for the given kind. */
export function buildAnimState(kind: TileAnimKind): TileAnimState | null {
  const startedAt = performance.now();
  switch (kind) {
    case 'buyout':
      return { kind: 'buyout', startedAt };
    case 'claim':
      return { kind: 'claim', startedAt };
    case 'forfeit':
      return { kind: 'forfeit' };
    case 'waterfall':
      return { kind: 'waterfall', startedAt, durationMs: 6000 };
    case 'dutchAuction':
      return { kind: 'dutchAuction', startedAt, durationMs: 8000 };
    case 'reset':
      return null;
  }
}
